import ReactGA from 'react-ga4'
import { IDatadogAction, ITrackEventGA } from './interfaces/analyticsInterfaces'
import { datadogRum } from '@datadog/browser-rum'

interface ICustomEventsProps {
  action: string
  category: string
  label?: string
  value?: number
}

// See all options in https://developers.google.com/analytics/devguides/collection/ga4/reference/events
export type EventNameTypes = 'login' | 'search'

interface IEventProps {
  name: EventNameTypes
  params?: any
}

export const trackGACustomEvent = ({ action, category, label, value }: ICustomEventsProps) => {
  const trackEvent: ITrackEventGA = {
    action,
    category,
    label,
    value,
  }

  // Track for Google Analitycs
  ReactGA.event(trackEvent)
}

export const trackEvent = ({ name, params }: IEventProps) => {
  ReactGA.event(name, params)
}

export const trackDatadogAction = ({ name, value, item }: IDatadogAction) => {
  datadogRum.addAction(name, {
    value,
    item,
  })
}
